import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2, jkLib, dateFormatter, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Stkme } from '../entity/Stkme-angular';


@Injectable({
  providedIn: 'root'
})
export class StkmeServicePkg extends JkEntityV2 {


  constructor() {
    super();
    this.linkMasterFields = '';
    this.defaultItem = new Stkme();
    this.entityType.type = EntityType.master;
    this.columnLabel = {
      COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
      ME001: '群組代號', ME002: '群組名稱', ME003: '備註', ME004: '排序碼', ME005: '更新碼', ME006: '平均漲幅', ME007: '前1/3漲跌幅%', ME008: '末1/3漲跌幅%', ME009: '最大漲幅%', ME010: '更新時間', ME011: '趨勢', ME012: '漲幅超過N%通知', ME013: '熱力圖分析', ME014: '條件代號'
    };

    this.fieldNames = 'ME001,ME002,ME003,ME004,ME005,ME006,ME007,ME008,ME009,ME010,ME011,ME012,ME013,ME014';
    this.fieldLengths = { ME001: 6, ME002: 10, ME003: 255, ME004: 4, ME005: 1, ME006: 8.4, ME007: 8.4, ME008: 8.4, ME009: 8.4, ME010: 8, ME011: 8, ME012: 6.3, ME013: 1, ME014: 6 };
    this.columnDefs = [
      { field: "ME001", headerName: "群組代號", headerTooltip: "", width: 118, cellDataType: "text", },
      { field: "ME002", headerName: "群組名稱", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "ME003", headerName: "備註", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "ME004", headerName: "排序碼", headerTooltip: "", width: 102, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "ME005", headerName: "更新碼", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "ME006", headerName: "平均漲幅", headerTooltip: "", width: 137, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "ME007", headerName: "前1/3漲跌幅%", headerTooltip: "", width: 137, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "ME008", headerName: "末1/3漲跌幅%", headerTooltip: "", width: 137, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "ME009", headerName: "最大漲幅%", headerTooltip: "", width: 137, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "ME010", headerName: "更新時間", headerTooltip: "", width: 134, cellDataType: "text", },
      { field: "ME011", headerName: "趨勢", headerTooltip: "", width: 134, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "ME012", headerName: "漲幅超過N%通知", headerTooltip: "", width: 120, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "ME013", headerName: "熱力圖分析", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "ME014", headerName: "條件代號", headerTooltip: "", width: 118, cellDataType: "text", },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'STKME';
    this.isSys = false;
    this.sqlSelect = `SELECT STKME.*  FROM STKME`;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY ME001`;
    this.keyFields = ['ME001'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['ME001'];
    this.seqField = '';
    this.seqFieldLength = 4;
  }
  override async validateItem(item: Stkme): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

override async newRecord(newItem: Stkme): Promise<Stkme> {
    await super.newRecord(newItem);
    return newItem;
  }




}

// 客製開始====================================================
